
export default {
  name: 'TruncateText',
  props: {
    classes: { type: String, default: '' },
    text: { type: String, default: '' },
    maxChars: { type: Number, default: 150 },
    showBtnReadMore: { type: Boolean, default: true },
    stripTags: { type: Array, default: () => [] },
  },
  data() {
    return {
      truncate: true,
    }
  },
  computed: {
    textLength() {
      return (
        this.text
          ?.replace(/<[^>]*>/g, '')
          .replace(/&[^;]+;/g, ' ')
          .trim().length || 0
      )
    },
    needsTruncation() {
      return this.textLength > this.maxChars
    },
  },
}
